import { TripInformationConstants } from '../store/tripInformation.constants'
import { OptionsConstants } from '../../options/store/options.constants'

// TODO: Add this line to src\features\validation\schemas\index.ts
// export { tripInformationSchemas } from '../../tripInformation/validation/tripInformation.schema'

export const tripInformationSchemas = [
  {
    inputKey: TripInformationConstants.SET_BASE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_BASE: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_BASE'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_BASE: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_BASE_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_BASE_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_BASE_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_BASE_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_UNIT,
    isNumber: false,
    type: 'object',
    properties: {
      SET_UNIT: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_UNIT'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_UNIT: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_UNIT_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_UNIT_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_UNIT_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_UNIT_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_STAFFING_LEVEL,
    isNumber: false,
    type: 'object',
    properties: {
      SET_STAFFING_LEVEL: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_STAFFING_LEVEL'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_STAFFING_LEVEL: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_STAFFING_LEVEL_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_STAFFING_LEVEL_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_STAFFING_LEVEL_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_STAFFING_LEVEL_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_SHIFT,
    isNumber: false,
    type: 'object',
    properties: {
      SET_SHIFT: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_SHIFT'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_SHIFT: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_SHIFT_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_SHIFT_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_SHIFT_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_SHIFT_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_DISPATCH_ID,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPATCH_ID: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPATCH_ID'],
    errorMessage: {
      properties: {
        SET_DISPATCH_ID: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_REGISTRATION_TAIL_NUMBER,
    isNumber: false,
    type: 'object',
    properties: {
      SET_REGISTRATION_TAIL_NUMBER: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_REGISTRATION_TAIL_NUMBER'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_REGISTRATION_TAIL_NUMBER: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_REGISTRATION_TAIL_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_REGISTRATION_TAIL_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_REGISTRATION_TAIL_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_REGISTRATION_TAIL_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_DISPATCH_PRIORITY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPATCH_PRIORITY: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPATCH_PRIORITY'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_DISPATCH_PRIORITY: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_DISPATCH_PRIORITY_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPATCH_PRIORITY_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPATCH_PRIORITY_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_DISPATCH_PRIORITY_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_TYPE_OF_SERVICE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TYPE_OF_SERVICE: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_TYPE_OF_SERVICE'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_TYPE_OF_SERVICE: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_TYPE_OF_SERVICE_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_TYPE_OF_SERVICE_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_TYPE_OF_SERVICE_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_TYPE_OF_SERVICE_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_SCHEDULED,
    isNumber: false,
    type: 'object',
    properties: {
      SET_SCHEDULED: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_SCHEDULED'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_SCHEDULED: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_SCHEDULED_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_SCHEDULED_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_SCHEDULED_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_SCHEDULED_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_PATIENT_CATEGORY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_PATIENT_CATEGORY: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_PATIENT_CATEGORY'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_PATIENT_CATEGORY: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_PATIENT_CATEGORY_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_PATIENT_CATEGORY_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_PATIENT_CATEGORY_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_PATIENT_CATEGORY_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_DISPATCHED_AS,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPATCHED_AS: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPATCHED_AS'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_DISPATCHED_AS: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_DISPATCHED_AS_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPATCHED_AS_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPATCHED_AS_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_DISPATCHED_AS_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_DISPOSITION,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPOSITION: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPOSITION'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_DISPOSITION: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_DISPOSITION_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPOSITION_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPOSITION_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_DISPOSITION_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_AMBULANCE_TRANSPORT_CODE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_AMBULANCE_TRANSPORT_CODE: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_AMBULANCE_TRANSPORT_CODE'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_AMBULANCE_TRANSPORT_CODE: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_AMBULANCE_TRANSPORT_CODE_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_AMBULANCE_TRANSPORT_CODE_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_AMBULANCE_TRANSPORT_CODE_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_AMBULANCE_TRANSPORT_CODE_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_MASS_CASUALTY,
    isNumber: false,
    type: 'object',
    properties: {
      SET_MASS_CASUALTY: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_MASS_CASUALTY'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_MASS_CASUALTY: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_MASS_CASUALTY_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_MASS_CASUALTY_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_MASS_CASUALTY_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_MASS_CASUALTY_OPTIONS: 'error',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_DISPATCH_LOCATION,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPATCH_LOCATION: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPATCH_LOCATION'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_DISPATCH_LOCATION: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: TripInformationConstants.SET_VEHICLE_GRID,
    isNumber: false,
    type: 'object',
    properties: {
      SET_VEHICLE_GRID: {
        type: 'string',
        // ToDo: confirm Pattern is set correctly
        pattern: '^([\x20-\x7F]){1,50}$',
      },
    },
    additionalProperties: false,
    required: ['SET_VEHICLE_GRID'],
    //ToDo: update max length below/ set custom error message
    errorMessage: {
      properties: {
        SET_VEHICLE_GRID: 'Must be alphanumeric with max length of 50',
      },
    },
  },
  {
    inputKey: OptionsConstants.SET_VEHICLE_GRID_OPTIONS,
    //ToDo: set isNumber correctly
    isNumber: false,
    type: 'object',
    properties: {
      SET_VEHICLE_GRID_OPTIONS: {
        //ToDo: set Type correctly & add any min/max/ patterns
        //type: 'string',
      },
    },
    additionalProperties: false,
    required: ['SET_VEHICLE_GRID_OPTIONS'],
    //ToDo: set custom error message
    errorMessage: {
      properties: {
        SET_VEHICLE_GRID_OPTIONS: 'error',
      },
    },
  },
]
